export enum PartnerSet {
	Partners = "Partners",
	Clients = "Clients",
}
